// RIASEC (O*NET Interest Profiler) presentation constants — client-side labels
// & colors only. Scores always come from the O*NET Web Services API; this file
// never computes scores. Kept fully separate from the TSB framework.

export const ONET_ATTRIBUTION =
  "This career interest assessment uses the O*NET Interest Profiler, developed by the U.S. Department of Labor, Employment & Training Administration (USDOL/ETA). O*NET® is a trademark of USDOL/ETA. Scores and career matches are provided by the O*NET Web Services.";

// O*NET Web Services license requires a visible credit AND a link back.
export const ONET_URL = "https://services.onetcenter.org/";

export const RIASEC = {
  Realistic: {
    key: "Realistic", tag: "Doers", color: "#c2410c",
    blurb: "Hands-on work with tools, machines, plants, or animals. Practical, physical, and results-oriented.",
  },
  Investigative: {
    key: "Investigative", tag: "Thinkers", color: "#1d4ed8",
    blurb: "Working with ideas and solving problems. Research, analysis, and figuring out how things work.",
  },
  Artistic: {
    key: "Artistic", tag: "Creators", color: "#7c3aed",
    blurb: "Creative expression through design, writing, music, or performance. Open-ended, imaginative work.",
  },
  Social: {
    key: "Social", tag: "Helpers", color: "#059669",
    blurb: "Helping, teaching, and working with people. Communication, service, and support.",
  },
  Enterprising: {
    key: "Enterprising", tag: "Persuaders", color: "#b91c1c",
    blurb: "Leading, persuading, and starting things. Business, sales, and taking initiative.",
  },
  Conventional: {
    key: "Conventional", tag: "Organizers", color: "#0891b2",
    blurb: "Working with data, detail, and structure. Organizing, records, and following clear procedures.",
  },
};

export function riasecMeta(title) {
  const key = (title || "").trim();
  return RIASEC[key] || { key, tag: "", color: "#64748b", blurb: "" };
}
